// extracted by mini-css-extract-plugin
export default {"wrapper":"SendSepa_wrapper__ZEq6H","input":"SendSepa_input__1HLIj"};